<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="/">
                <img
                    class="navbar-brand-full"
                    src="../../src/assets/img/codelab-logo.png"
                    width="220"
                    height="30"
                    alt="Witcloud Logo "
                />
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" />
            <b-col md="3">
                <v-select
                    class="text-nowrap"
                    v-model="project"
                    label="name"
                    placeholder="Select project"
                    :options="projects"
                ></v-select>
            </b-col>

            <b-navbar-nav class="d-md-down-none ml-auto">
                <b-nav-item class="d-md-down-none">
                    <DefaultHeaderDropdown />
                </b-nav-item>
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader />
                <SidebarForm />
                <SidebarNav :navItems="navItems"></SidebarNav>
                <!-- <SidebarFooter>
                    <router-link to="/customqueries"> <i class="fa fa-star"> </i> Custom Queries</router-link>
                </SidebarFooter> -->
                <SidebarMinimizer />
            </AppSidebar>
            <main class="main">
                <Breadcrumb :list="list" class="default-breadcrumb" />
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
                <!--aside-->
                <DefaultAside />
            </AppAside>

            <b-modal
                ref="issue-modal"
                v-model="issueModalVisible"
                size="md"
                centered
                hide-footer
                title="Fill issue form"
                header-bg-variant="info"
            >
                <b-form @submit.stop.prevent v-if="!messageSent">
                    <b-form-group label="Topic">
                        <b-form-input
                            v-model="$v.issueForm.topic.$model"
                            placeholder="Enter issue topic"
                        ></b-form-input>
                    </b-form-group>

                    <Feedback :state="validateRef('issueForm.topic')" invalid="Enter issue topic"></Feedback>

                    <b-form-group label="Category">
                        <v-select
                            style="z-index: 999"
                            v-model="$v.issueForm.category.$model"
                            placeholder="Select issue category"
                            :options="issueCategories"
                        ></v-select>
                    </b-form-group>

                    <Feedback :state="validateRef('issueForm.category')" invalid="Select issue category"></Feedback>

                    <b-form-group label="Description">
                        <b-form-textarea
                            v-model="$v.issueForm.description.$model"
                            rows="3"
                            placeholder="Enter issue description"
                        ></b-form-textarea>
                    </b-form-group>

                    <Feedback
                        :state="validateRef('issueForm.description')"
                        invalid="Enter issue description"
                    ></Feedback>
                    <b-form-group label="Screenshot(optional)">
                        <b-form-file
                            ref="screen-file"
                            @change="handleFileUpload"
                            v-model="issueForm.screen.file"
                            :state="issueForm.screen.isValid"
                            placeholder="Attach issue screenshots"
                            drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </b-form-group>

                    <br />
                    <b-button @click="createIssue" type="submit" variant="primary">Submit</b-button>
                </b-form>
                <p v-else>Thank you for reporting, we will review it as soon as possible</p>
            </b-modal>
        </div>

        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import Vue from 'vue'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import {required, between} from 'vuelidate/lib/validators'

import nav from '@/_nav'
import store from '../store/index'
import EventBus from '../eventBus'

import {mapGetters} from 'vuex'

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading'

import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb,
} from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'

export default {
    components: {
        AsideToggler,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        DefaultAside,
        DefaultHeaderDropdown,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
        Feedback,
        Loading,
    },
    data() {
        return {
            navItems: nav.items,
            issueModalVisible: false,
            messageSent: false,
            issueForm: {
                topic: null,
                category: null,
                description: null,
                screen: {
                    file: null,
                    isValid: null,
                },
            },
            issueCategories: [],
        }
    },
    validations: {
        issueForm: {
            topic: {
                required,
            },
            category: {
                required,
            },
            description: {
                required,
            },
        },
    },
    methods: {
        async showIssueModal() {
            const {
                data: {categories},
            } = await this.axios.get(`${process.env.VUE_APP_NODE_API_HOST}/issue/categories`)

            this.issueCategories = categories
            this.messageSent = false
            this.issueModalVisible = !this.issueModalVisible
        },
        async createIssue() {
            if (this.$v.issueForm.$invalid) {
                this.$v.issueForm.$touch()
                return
            }

            let formData = new FormData()
            formData.append('topic', this.issueForm.topic)
            formData.append('category', this.issueForm.category)
            formData.append('description', this.issueForm.description)

            if (this.issueForm.screen.file) {
                formData.append('screen', this.issueForm.screen.file)
            }

            this.messageSent = true
            await this.axios.post(process.env.VUE_APP_NODE_API_HOST + '/issue', formData)

            this.issueForm = {
                topic: null,
                category: null,
                description: null,
                screen: {
                    file: null,
                    isValid: null,
                },
            }
        },
        handleFileUpload() {
            this.issueForm.screen.file = this.$refs['screen-file'].files
        },
        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },
    },
    computed: {
        name() {
            return this.$route.name
        },
        list() {
            return this.$route.matched.filter(route => route.name || route.meta.label)
        },
        project: {
            get() {
                return this.$store.state.project.active
            },

            set(value) {
                this.$store.commit('project/SET_PROJECT', value)
                EventBus.$emit('projectChange', true)
                this.$router.go()
            },
        },
        ...mapGetters({
            projects: 'project/projects',
        }),
    },
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';
</style>
